// @flow
import React, { useContext, useEffect } from 'react';
import { useDispatch } from 'react-redux';

import graphQLClient from 'Utils/graphql-client/graphqlClient';
import ReactAppContext from 'Context/ReactAppContext';
import { GET_SELLER_EMAIL } from 'Store/seller/sellerInfoReducer';

export const CMTA = () => {
  const appContext = useContext(ReactAppContext);
  const dispatch = useDispatch();

  useEffect(() => {
    if (!appContext.isCmta) {
      return;
    }

    graphQLClient
      .runNoCacheQuery(
        `{
      sellerInfo {
        email
      }
    }`,
        appContext,
      )
      .then(data => {
        dispatch({
          type: GET_SELLER_EMAIL,
          payload: data,
        });
      });
  }, []);

  return null;
};
